/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const newsYearList = () => {
		if($('.js-news-yearList').length) {
			var latest = $('.js-news-latest-year').text();
			var earliest = $('.js-news-earliest-year').text();
			let category = location.pathname.split('/')[3];
			let directoryYear = location.pathname.split('/')[2];
			let newsVal;
			const optionVal = (_num) => {
				if(directoryYear === '') {
					return '/news/'+_num+'/';
				} else if(directoryYear.indexOf('2') !== -1) {
					if(category === '') {
						return '/news/'+_num+'/';
					} else {
						return '/news/'+_num+'/'+category+'/';
					}
				} else {
					return '/news/'+_num+'/'+location.pathname.split('/')[2]+'/';
				}
			};
			if(directoryYear === '') {
				newsVal = '/news/';
			} else if(directoryYear.indexOf('2') !== -1) {
				if(category === '') {
					newsVal = '/news/';
				} else {
					newsVal = '/news/'+category+'/';
				}
			} else {
				newsVal = '/news/'+location.pathname.split('/')[2]+'/';
			}
			// optionを追加
			$('.js-news-yearList').append($('<option>').html('最新').val(newsVal));
			for(var i =latest; i>=earliest; i--) {
				$('.js-news-yearList').append($('<option>').html(''+i+'').val(optionVal(i)));
			}
			// 見ている年をselected
			$('.js-news-yearList').val(location.pathname);
			// 選択した年に飛ばす
			$('.js-news-yearList').change(function(){
				location.href = $(this).val();
			});
		}
	};
	const newsCurrent = () => {
		if($('.news-tab').length) {
			for(var i=0; i<$('.news-tab .news-tab-btn-wrap .news-tab-btn').length; i++) {
				if(location.pathname.replace('index.html','') === $('.news-tab .news-tab-btn-wrap .news-tab-btn').eq(i).attr('href')) {
					$('.news-tab .news-tab-btn-wrap .news-tab-btn').eq(i).addClass(a);
				}
			}
		}
	};
	newsYearList();
	newsCurrent();

})(window.jQuery, window.FUNCTIONS);
